import { render, staticRenderFns } from "./GestaoPerdasEstoqueContainer.vue?vue&type=template&id=9a19cf1a&scoped=true"
import script from "./GestaoPerdasEstoqueContainer.vue?vue&type=script&lang=js"
export * from "./GestaoPerdasEstoqueContainer.vue?vue&type=script&lang=js"
import style0 from "./GestaoPerdasEstoqueContainer.vue?vue&type=style&index=0&id=9a19cf1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a19cf1a",
  null
  
)

export default component.exports